import script from "./Poster.vue?vue&type=script&lang=ts&setup=true&name=Poster"
export * from "./Poster.vue?vue&type=script&lang=ts&setup=true&name=Poster"

import "./Poster.vue?vue&type=style&index=0&id=948c15c6&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-948c15c6"]])

export default __exports__